// pro regular icons (far)
const icons = [
    'faAt',
    'faAddressBook',
    'faAddressCard',
    'faAlignCenter',
    'faAlignJustify',
    'faAlignLeft',
    'faAlignRight',
    'faAnalytics',
    'faAngleDown',
    'faAngleLeft',
    'faAngleUp',
    'faAngleRight',
    'faArchive',
    'faArrowDown',
    'faArrowDownWideShort',
    'faArrowFromLeft',
    'faArrowToRight',
    'faArrowLeft',
    'faArrowRight',
    'faArrowsAlt',
    'faArrowAltRight',
    'faArrowCircleRight',
    'faArrowTrendUp',
    'faArrowTrendDown',
    'faArrowsToLine',
    'faArrowUp',
    'faArrowUpRightFromSquare',
    'faArrowUpShortWide',
    'faAsterisk',
    'faBadge',
    'faBadgeCheck',
    'faBallot',
    'faBars',
    'faBan',
    'faBell',
    'faBook',
    'faBold',
    'faBookmark',
    'faBookBookmark',
    'faBookMedical',
    'faBoxOpen',
    'faBracketsCurly',
    'faBriefcase',
    'faBroomWide',
    'faBullhorn',
    'faBullseye',
    'faBuilding',
    'faBuildingUser',
    'faCabinetFiling',
    'faCakeCandles',
    'faCalculatorSimple',
    'faCalendar',
    'faCalendarAlt',
    'faCalendarCheck',
    'faCalendarClock',
    'faCalendarDay',
    'faCalendarEdit',
    'faCalendarExclamation',
    'faCalendarLines',
    'faCalendarMinus',
    'faCalendarPlus',
    'faCalendarStar',
    'faCalendarTimes',
    'faCalendarWeek',
    'faCamera',
    'faCaretSquareDown',
    'faCheck',
    'faCheckDouble',
    'faCheckSquare',
    'faCheckCircle',
    'faChevronDoubleDown',
    'faChevronDoubleDown',
    'faChevronLeft',
    'faChevronRight',
    'faChevronDoubleUp',
    'faChevronDown',
    'faChevronLeft',
    'faChevronRight',
    'faChevronUp',
    'faChartSimple',
    'faCircle',
    'faCircleBolt',
    'faCircleCheck',
    'faCircleHalfStroke',
    'faCircleMinus',
    'faCirclePlus',
    'faCircleNotch',
    'faCirclePause',
    'faClipboardListCheck',
    'faClock',
    'faCloudUpload',
    'faCloudDownload',
    'faCode',
    'faCodeBranch',
    'faCog',
    'faColumns',
    'faCommentAlt',
    'faCommentAltLines',
    'faCommentAltSmile',
    'faCommentCheck',
    'faCommentEdit',
    'faCommentLines',
    'faCommentQuote',
    'faCommentSlash',
    'faCommentSms',
    'faComments',
    'faCommentsQuestionCheck',
    'faCompressAlt',
    'faCopy',
    'faDiagnoses',
    'faDial',
    'faDialMax',
    'faDialMedLow',
    'faDialMin',
    'faDirections',
    'faDollarSign',
    'faDoorClosed',
    'faDoorOpen',
    'faDotCircle',
    'faDownload',
    'faDna',
    'faEdit',
    'faEllipsisV',
    'faEngineWarning',
    'faEnvelope',
    'faExclamationCircle',
    'faExclamationTriangle',
    'faExpandAlt',
    'faExternalLink',
    'faEye',
    'faEyeSlash',
    'faFax',
    'faFileAlt',
    'faFileCertificate',
    'faFileChartLine',
    'faFileCheck',
    'faFileCircleCheck',
    'faFileCircleXmark',
    'faFileContract',
    'faFileDownload',
    'faFileEdit',
    'faFileExcel',
    'faFileCsv',
    'faFileExclamation',
    'faFileImage',
    'faFileWord',
    'faFile',
    'faFiles',
    'faFilePdf',
    'faFilePowerpoint',
    'faFileVideo',
    'faFileImport',
    'faFileInvoice',
    'faFileInvoiceDollar',
    'faFileMedicalAlt',
    'faFilePlus',
    'faFileSearch',
    'faFileSlash',
    'faFileSignature',
    'faFileTimes',
    'faFilter',
    'faFingerprint',
    'faFlag',
    'faFlagCheckered',
    'faArrowsUpDown',
    'faFolder',
    'faFolderArrowDown',
    'faFolderImage',
    'faFolderPlus',
    'faFolders',
    'faFont',
    'faGavel',
    'faGlasses',
    'faGlobe',
    'faGlobeAmericas',
    'faGrid2',
    'faGripDotsVertical',
    'faGripLines',
    'faGripVertical',
    'faHandHoldingHeart',
    'faHandHoldingUsd',
    'faHandshake',
    'faHandDots',
    'faHandsUsd',
    'faHashtag',
    'faHdd',
    'faH1',
    'faH2',
    'faH3',
    'faH4',
    'faHeartbeat',
    'faHistory',
    'faHome',
    'faHomeLgAlt',
    'faHorizontalRule',
    'faHouseUser',
    'faHourglass',
    'faHospitals',
    'faIdBadge',
    'faIdCard',
    'faInboxIn',
    'faInboxOut',
    'faInfoCircle',
    'faInputText',
    'faItalic',
    'faLanguage',
    'faLaptopCode',
    'faLayerGroup',
    'faLayerPlus',
    'faLevelDown',
    'faLevelUp',
    'faLightbulb',
    'faLineColumns',
    'faLink',
    'faLinkSlash',
    'faList',
    'faListAlt',
    'faListUl',
    'faListOl',
    'faLaptopHouse',
    'faLockAlt',
    'faLocationDot',
    'faKey',
    'faMagic',
    'faMagnifyingGlass',
    'faMailbox',
    'faMap',
    'faMapMarkedAlt',
    'faMapMarkerAlt',
    'faMapMarkerCheck',
    'faMapMarkerEdit',
    'faMapMarkerPlus',
    'faMedkit',
    'faMemoCircleInfo',
    'faMemoCircleCheck',
    'faMessageMedical',
    'faMinusCircle',
    'faMinusSquare',
    'faMobile',
    'faMoneyCheckAlt',
    'faNoteMedical',
    'faNotesMedical',
    'faObjectGroup',
    'faObjectUngroup',
    'faPager',
    'faPalette',
    'faPaperclip',
    'faPaperPlane',
    'faPaperPlaneTop',
    'faParagraph',
    'faPauseCircle',
    'faPen',
    'faPenAlt',
    'faPencil',
    'faPenRuler',
    'faPeopleArrows',
    'faPeopleGroup',
    'faPeopleRoof',
    'faPeopleSimple',
    'faPhone',
    'faPhoneOffice',
    'faPhoneRotary',
    'faPills',
    'faPlateUtensils',
    'faPlay',
    'faPlayCircle',
    'faPlus',
    'faPortalEnter',
    'faPortalExit',
    'faPrescription',
    'faPrescriptionBottleMedical',
    'faPrint',
    'faPuzzlePiece',
    'faRobot',
    'faQuestionCircle',
    'faQuoteLeft',
    'faQuoteRight',
    'faQuotes',
    'faRadar',
    'faRandom',
    'faReceipt',
    'faRectangleHistoryCircleUser',
    'faRectangleLandscape',
    'faRedo',
    'faRegistered',
    'faRepeat',
    'faReplyClock',
    'faRightLeftLarge',
    'faRotate',
    'faRoute',
    'faSackXmark',
    'faSave',
    'faSearch',
    'faSearchMinus',
    'faSearchPlus',
    'faShareNodes',
    'faShieldCheck',
    'faShieldExclamation',
    'faSignature',
    'faSignatureSlash',
    'faSignatureLock',
    'faSignOutAlt',
    'faSitemap',
    'faSlidersH',
    'faSort',
    'faSortNumericUpAlt',
    'faSpinner',
    'faSquare',
    'faSquareKanban',
    'faStar',
    'faStepBackward',
    'faStepForward',
    'faStopCircle',
    'faStopwatch20',
    'faStreetView',
    'faStrikethrough',
    'faSync',
    'faTag',
    'faTags',
    'faTable',
    'faTasks',
    'faTally',
    'faText',
    'faTextSize',
    'faThList',
    'faTimelineArrow',
    'faTimes',
    'faTimesCircle',
    'faToggleOn',
    'faToggleOff',
    'faTransporter2',
    'faTrash',
    'faTrashAlt',
    'faTrees',
    'faTruckMedical',
    'faUmbrella',
    'faUnderline',
    'faUndo',
    'faUniversity',
    'faUnlock',
    'faUnlockAlt',
    'faUpload',
    'faUsbDrive',
    'faUser',
    'faUserChart',
    'faUserCheck',
    'faUserCog',
    'faUserDoctor',
    'faUserDoctorMessage',
    'faUserEdit',
    'faUserFriends',
    'faUserGraduate',
    'faUserLock',
    'faUserMd',
    'faUserPlus',
    'faUserShield',
    'faUserTag',
    'faUserTie',
    'faUserUnlock',
    'faUsers',
    'faUsersClass',
    'faUsersCog',
    'faUsersMedical',
    'faUsersRectangle',
    'faWandMagicSparkles',
    'faClipboardList',
    'faListTimeline',
    'faFlask',
    'faStethoscope',
    'faHospitalUser',
    // Freshdesk triage (#4423)
    'faLock',
    'faNoteSticky',
    'faArrowRotateRight',
    'faXmark',
    'faMinus',
    'faVial',
    'faVials',
    'faVideo',
    'faCalendarXmark',
    'faUserGroup',
    'faTriangleExclamation',
    'faShieldHalved',
    'faSliders',
    'faMicrophone',
    'faDatabase',
    'faCircleInfo',
    'faBrainCircuit',
    // BenjiPays update payment details (#4877)
    'faCreditCard',
    // Freshdesk transfer to department (#4855)
    'faArrowRightArrowLeft',
    'faCaretDown',
    // Eligibility check button (#4908) — faListTimeline is already registered above
    'faClipboardQuestion',
    'faClipboardUser',
    'faEnvelopeOpen',
    'faFileCirclePlus',
    'faInbox',
    'faRotate',
    'faUserSlash',
    // Location estate shapes (#5774) — faLocationDot, faBuilding, faLayerGroup, faGripLines and faDoorOpen are already registered above
    'faHouse',
    'faDiagramProject',
    'faHospital',
    'faBed',
    'faCartFlatbed',
    'faVanShuttle',
    'faBoxArchive',
    // Telehealth video dock controls (#5015)
    'faMicrophoneSlash',
    'faVideoSlash',
    'faPhoneSlash',
    'faUserXmark',
    // Telehealth in-session sharing (#5040)
    'faShareNodes',
    'faChalkboard',
    'faFileLines',
    // Telehealth screen share — distinct from faShareNodes, which is content sharing
    'faDisplay',
    'faDisplaySlash',
    // Lens Help answer rating (#6535)
    'faThumbsUp',
    'faThumbsDown',
    // Help documentation manager: compare two versions, show a check's result (#6561)
    'faCodeCompare',
    'faListCheck',
];

// Import all icons
import * as iconsModule from '@fortawesome/pro-regular-svg-icons';

export default (library) => {
    // Add all icons to the library
    icons.forEach((iconName) => {
        if (iconsModule[iconName]) {
            library.add(iconsModule[iconName]);
        }
    });
};
